import {useContext} from "react";
import {BackgroundContext} from "../BackgroundColorProvider/BackgroundColorProvider";

export default function useBackgroundColor() {
    return useContext(BackgroundContext);
}
